import { useTheme } from '@mui/system';
import React from 'react';
import FileDataActivity from 'src/sections/file-manager/file-data-activity';

type ChartData = {
  ArchiveProjectCost: number;
  ArchiveLicensingCost: number;
  ApplicationCosts: number;
  BaselineBudgetSavings: number;
};

const data: ChartData[] = [
  {
    ArchiveProjectCost: 0.3,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 10,
    BaselineBudgetSavings: 1,
  },
  {
    ArchiveProjectCost: 0.4,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 10,
    BaselineBudgetSavings: 0.9,
  },
  {
    ArchiveProjectCost: 0.5,
    ArchiveLicensingCost:0.2,
    ApplicationCosts: 9,
    BaselineBudgetSavings: 2.3,
  },
  {
    ArchiveProjectCost: 0.6,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 8,
    BaselineBudgetSavings: 3.2,
  },
  {
    ArchiveProjectCost: 0.5,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 5,
    BaselineBudgetSavings: 6.8,
  },
  {
    ArchiveProjectCost: 0.4,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 3,
    BaselineBudgetSavings: 9.4,
  },
  {
    ArchiveProjectCost: 0.3,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 0.5,
    BaselineBudgetSavings: 12,
  },
  {
    ArchiveProjectCost: 0.3,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 0.5,
    BaselineBudgetSavings: 13,
  },
  {
    ArchiveProjectCost: 0.2,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 0.5,
    BaselineBudgetSavings: 14.1,
  },
  {
    ArchiveProjectCost: 0.1,
    ArchiveLicensingCost: 0.2,
    ApplicationCosts: 0.5,
    BaselineBudgetSavings: 14.2,
  },
];
const TIME_LABELS = {
  week: ['Mon', 'Tue', 'Web', 'Thu', 'Fri', 'Sat', 'Sun'],
  month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  year: ['2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033'],
};
const ForecastBarGraph: React.FC = () => {
  const theme = useTheme();
  return (
    <>
      <div>
        <FileDataActivity
          title="Summary Report"
          chart={{
            labels: TIME_LABELS,
            colors: [
              theme.palette.secondary.main,
              theme.palette.info.darker,
              theme.palette.info.main,
              theme.palette.primary.light,
            ],
            series: [
              {
                type: 'Year',
                data: [
                  { name: 'ArchiveProjectCost', data: data.map((item) => item.ArchiveProjectCost) },
                  {
                    name: 'ArchiveLicensingCost',
                    data: data.map((item) => item.ArchiveLicensingCost),
                  },
                  { name: 'ApplicationCosts', data: data.map((item) => item.ApplicationCosts) },
                  {
                    name: 'BaselineBudgetSavings',
                    data: data.map((item) => item.BaselineBudgetSavings),
                  },
                ],
              },
            ],
          }}
        />
      </div>
    </>
  );
};

export default ForecastBarGraph;
